import React from 'react';
import classnames from 'classnames';
import { PapiDeviation } from '@wix/da-types-papi';
import DeviationDumbView from '@wix/da-shared-react/pkg/DeviationViews/Dumbo';
import { DeviationLink } from '@wix/da-shared-react/pkg/Duperbrowse';
import { isImageDeviation } from '@wix/da-shared-react/pkg/DeviationViews/_helpers';
import Overlay from '@wix/da-shared-react/pkg/DeviationViews/Thumb/Standard/Overlay';
import DeviationImageCoverView from './DeviationImageCoverView';
import { SLIDESHOW_HEIGHT } from './DeviationSlideshow';
import s from './DeviationSlideshow.scss';

interface Props {
  deviation: PapiDeviation;
  containerWidth: number;
  useCoverMode: boolean;
  active?: boolean;
  visible?: boolean;
}

const Slide: React.FC<Props> = ({
  deviation,
  containerWidth,
  useCoverMode,
  active = true,
  visible = true,
}) => (
  <div
    className={classnames(s['slide'], active && s['active'])}
    title={deviation.title}
    style={{
      height: SLIDESHOW_HEIGHT,
      visibility: visible ? 'visible' : 'hidden',
    }}
  >
    {useCoverMode && isImageDeviation(deviation) ? (
      <DeviationImageCoverView
        className={s['deviation']}
        deviation={deviation}
        containerWidth={containerWidth}
        containerHeight={SLIDESHOW_HEIGHT}
      />
    ) : (
      <DeviationDumbView
        className={s['deviation']}
        deviation={deviation}
        width={containerWidth}
        height={SLIDESHOW_HEIGHT}
        noCropping={true}
      />
    )}
    {/* To avoid nested anchors we render DeviationLink as a sibling of Overlay
        and absolutely positioned to cover the entire Slide. */}
    <DeviationLink
      className={s['deviation-link']}
      deviation={deviation}
      title={deviation.title}
    />

    {visible && <Overlay className={s['overlay']} deviation={deviation} />}
  </div>
);

export default React.memo(Slide);
